import React, { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const downloadCsv = (rows) => {
  const lines = ["email,signed_up,source", ...rows.map((r) => `${r.email},${r.created_at},"${(r.source || "").replace(/"/g, '""')}"`)];
  const url = URL.createObjectURL(new Blob([lines.join("\n")], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "kahani-subscribers.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const SubscribersDialog = ({ open, onOpenChange }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/admin/subscribers").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="subscribers-dialog" className="bg-[#12141D] border-white/10 text-gray-200 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center justify-between pr-6">
            <span data-testid="subscribers-count">Subscribers ({rows.length})</span>
            <Button data-testid="subscribers-download-csv-btn" size="sm" disabled={!rows.length} onClick={() => downloadCsv(rows)} className="bg-[#FF7A1A] hover:bg-[#FF8D3A] text-black">
              <Download className="w-4 h-4 mr-1.5" /> Download CSV
            </Button>
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-white/5">
          {loading ? (
            <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#FF7A1A]" /></div>
          ) : rows.length === 0 ? (
            <p className="py-10 text-center text-gray-500">No subscribers yet.</p>
          ) : (
            rows.map((r) => (
              <div key={r.id} data-testid={`subscriber-row-${r.email}`} className="py-2.5 flex items-center justify-between gap-3 text-sm">
                <span className="text-white truncate">{r.email}</span>
                <span className="text-gray-500 font-mono-kh text-xs shrink-0">{new Date(r.created_at).toLocaleDateString()} · {r.source || "—"}</span>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
